<template>
    <div class="Jur-Cadastro-Principal">
        <PageTitle icon="fa fa-group" main="Cadastro"
            sub="Cadastro -> Escritório / Advogados" />
        <div class="Jur-Cadastro-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Clientes" active><ClienteFornecedor /></b-tab>
                    <!-- <b-tab title="Advogados" active><Advogados /></b-tab> -->
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import ClienteFornecedor from '../ml18/Ml18ClienteFornecedor'
//import Advogados from '../juridico/Advogados'


export default {
    name: 'JuridicoPrincipal',    
    components: { PageTitle, ClienteFornecedor }
    
}
</script>

<style>

</style>






